export default __webpack_public_path__ + "static/icons-left-6f906b39c5efbe93a58a7d7e5e01a740.png";